import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { CompanyWorkerForms } from '../../../molecules/forms/CompanyWorkerForms';

// Custom components
import { BackdropLoading } from '../../../BackdropLoading';

// Styles
import { Container, Body, SectionRight, Spacer, } from './styles'
import { CustomButtonV2, ModalFooter, ModalHeader, ModalSubHeader } from '../../../../pages/styles';

// Utils
import { validateForm } from '../../../../utils/commonFunctions';
import { arrayMultipleData } from '../../../../utils/commonFunctions/returnArrayMultiple';
import { PlantApi } from '../../../../services/PlantApi';
import { WorkflowApi } from '../../../../services/WorkflowApi';

import moment from "moment";
import { CompanyWorkerApi } from '../../../../services/CompanyWorkerApi';
import { WorkerCertificateApi } from '../../../../services/WorkerCertificateApi';
import { toast } from 'react-toastify';
export const CompanyWorkerModalCard = ({ isEdit, data, dataCertificates, handleSave, handleClose }) => {

    const { t } = useTranslation();
    const plantApi = new PlantApi();
    const workflowApi = new WorkflowApi();
    const companyWorkerApi = new CompanyWorkerApi();
    const workerCertificateApi = new WorkerCertificateApi();


    const [form, setForm] = useState({
        identification: '',
        identificationDate: '',
        name: '',
        lastName: '',
        eps: '',
        arl: '',
        email: '',
        emergencyContactFullName: '',
        emergencyContactPhone: '',
        certificates: dataCertificates,
        certificateRoleIds: [],
        certificateRoleElectricalLevels: [],
        workerRoleId: '',
        assignations: [],
        authorizationPersonalData: false,
        file: null,
        epsFile: null,
        arlFile: null,
        fileName: '',
        fileEpsName: '',
        fileArlName: ''
    })
    const [errors, setErrors] = useState({
        identification: { error: '', field: t('worker.table.identification'), required: true },
        email: { error: '', field: t('worker.table.email'), required: false },
        identificationDate: { error: '', field: t('worker.table.identificationDate'), required: false },
        name: { error: '', field: t('worker.table.name'), required: true },
        lastName: { error: '', field: t('worker.table.lastName'), required: true },
        eps: { error: '', field: t('worker.table.eps'), required: false },
        arl: { error: '', field: t('worker.table.arl'), required: false },
        emergencyContactFullName: { error: '', field: t('worker.table.emergencyContactFullName'), required: false },
        emergencyContactPhone: { error: '', field: t('worker.table.emergencyContactPhone'), required: false },
        workerRoleId: { error: '', field: t('worker.table.specialty'), required: false },
        assignations: { error: '', field: t('worker.table.assignations'), required: false },
        authorizationPersonalData: { error: '', field: t('worker.table.authorizationPersonalData'), required: false },
        identificationDate: { error: '', field: t('worker.table.identificationDate'), required: false },
        arlSelect: {},
        epsSelect: {},
        arlStatus: '',
        epsStatus: '',
        certificateRoleElectricalLevels: { error: '', field: t('worker.table.class'), required: false },
        fileName: { error: '', field: t('worker.table.loadPdfFile'), required: false },
        fileEpsName: { error: '', field: t('worker.table.EpsLoadFile'), required: true },
        fileArlName: { error: '', field: t('worker.table.ArlLoadFile'), required: true }

    })
    const [isRetieTechnicalCertificate, setIsRetieTechnicalCertificate] = useState(false);
    const [specialties, setSpecialties] = useState([]);
    const [assignations, setAssignations] = useState([]);
    const [disabled, setDisabled] = useState(false)
    const [loading, setLoading] = useState(false)
    const [arrayArl, setArrayArl] = useState([])
    const [arrayEps, setArrayEps] = useState([])
    const [arrayRoleElectricalLevels, setArrayRoleElectricalLevels] = useState([])

    const RETIE_TECHNICAL_ID = 7;


    useEffect(() => {
        async function call() {
            setLoading(true)
            await getSpecialties();
            await LoadArlEntities()
            await LoadEpsEntities()
            const listAssignations = await getAssignations();

            if (data?.workerId) {

                console.log('Worker id modal', data.workerId)
                const listCertificatesRoles = await getCertificatesWithRoles(data.certificatesRoles);

                const retieTechnicalSelected = data.certificatesRoles?.some((el) => el.id === RETIE_TECHNICAL_ID);
                // Si está seleccionado el certificado Retie rol técnico llamar endpoint de clases
                let listRoleElectricalLevels = [];
                if (retieTechnicalSelected) {
                    listRoleElectricalLevels = await getRoleElectricalLevels();
                }

                setForm({
                    ...form,
                    id: data.workerId,
                    email: data.email,
                    identification: data.identification,
                    name: data.name,
                    lastName: data.lastName,
                    eps: data.epsList,
                    emergencyContactFullName: data.emergencyContactFullName,
                    emergencyContactPhone: data.emergencyContactPhone,
                    arl: data.arlList,
                    workerRoleId: data.workerRole,
                    companyId: data.companyId,
                    certificates: listCertificatesRoles,
                    assignations: data.assignations?.length > 0 ? arrayMultipleData(data.assignations, listAssignations) : [],
                    identificationDate: data.expeditionDate,
                    authorizationPersonalData: data.authorizationPersonalData ?? false,
                    arlSelect: data.arlId ?? {},
                    epsSelect: data.epsId ?? {},
                    arlStatus: data.arlList.arlStatus ?? '',
                    epsStatus: data.epsList.epsStatus ?? '',
                    certificateRoleElectricalLevels: arrayMultipleData(data.certificateRoleElectricalLevels, listRoleElectricalLevels),
                    fileName: getFileName(data.certificateRoleElectricalFilePath),
                    fileEpsName: getFileName(data.certificateEpsFilePath),
                    fileArlName: getFileName(data.certificateArlFilePath),
                })

                // Si está seleccionado el certificado Retie con rol técnico setear flag y campos requeridos
                if (retieTechnicalSelected) {
                    setIsRetieTechnicalCertificate(true);
                    setErrors(prev => ({
                        ...prev,
                        certificateRoleElectricalLevels: {
                            ...prev.certificateRoleElectricalLevels, required: true
                        },
                        fileName: {
                            ...prev.fileName, required: true
                        }
                    }));
                }
            }
            setLoading(false)
        }
        call()
    }, [])

    function getFileName(filePath) {
        if (filePath) {
            return filePath.split('/')?.[3] ?? filePath
        }
        return ''
    }

    function handleChange(event, name, type) {
        let value;

        if (type === 'check') {
            value = event.target.checked
        } else if (type === 'date') {
            const formattedDate = moment(new Date(event));
            value = formattedDate.isValid() ? formattedDate.format("YYYY/MM/DD") : null;
        } else if (type === 'select') {
            value = event
        }
        else {
            value = event.target.value
        };

        setForm(prev => ({ ...prev, [name]: value }));

        if (name === 'email') {
            checkEmailFormat(value);
        } else {
            setErrors(prev => ({
                ...prev,
                [name]: { ...prev[name], error: '' }
            }));
        }

        if (name === 'identificationDate') {
            const isDateFilled = event !== null && event !== '';

            setErrors(prev => ({
                ...prev,
                ['authorizationPersonalData']: {
                    ...prev.authorizationPersonalData,
                    required: isDateFilled,
                    error: isDateFilled && !form.authorizationPersonalData
                        ? t('common.mandatory', { field: prev.authorizationPersonalData.field })
                        : ''

                }    //In case its null or with content, the required propiertie takes the same boolean value
            }))
        }


    }


    async function handleChangeCertificates(value, certificateId) {
        setForm(prevForm => ({
            ...prevForm,
            certificates: prevForm.certificates.map(cert =>
                cert.id === certificateId ? { ...cert, selectedOptions: value } : cert
            )
        }));

        // certificateId = 2 -> Certificado Retie
        // val.id = 7 -> Rol técnico
        // Si esto es true se setea la flag isRetieTechnicalCertificate para mostrar select Clase y campo archivo
        if (certificateId === 2) {
            const isTechnical = value.some(val => val.id === RETIE_TECHNICAL_ID);
            if (isTechnical) {
                await getRoleElectricalLevels();
            }

            setIsRetieTechnicalCertificate(isTechnical);
            setErrors(prev => ({
                ...prev,
                certificateRoleElectricalLevels: {
                    ...prev.certificateRoleElectricalLevels, required: isTechnical
                },
                fileName: {
                    ...prev.fileName, required: isTechnical
                }
            }));
        }
    }

    async function handleChangeFile(e, typeFile) {

        //let toastShow = toast.info(t('worker.messages.validateCertificates.validationInProgress'), { autoClose: false });   


        if(!form.identification || !form.name || !form.lastName || !form.eps.name || !form.arl.name)
        {
            toast.error(t('worker.messages.validateCertificates.validationFields'))
            return
        }
        
        let type = typeFile === 'eps' ? 'HEALTH' : 'ARL'

        let file = e.target.files[0];

        if (file) {

            setLoading(true)

            let toastShow = toast.info(t('worker.messages.validateCertificates.validationInProgress'), { autoClose: false }); 

            const validation = await ValidateCertificates(file, type);


            if (validation.isValid) {
                if (typeFile === 'eps') {
                    setErrors(prev => ({ ...prev, fileEpsName : { ...prev['fileEpsName'], error: ''}}))
                }
                else if (typeFile === "arl") {
                    setErrors(prev => ({ ...prev, fileArlName : {...prev['fileArlName'], error: ''}}))
                }
                toast.success( t('worker.messages.validateCertificates.validationSuccess'))
                toast.dismiss(toastShow);
                setLoading(false)

            } else {

                if (typeFile === 'eps') 
                { 
                    setErrors(prev => ({ ...prev, fileEpsName : { ...prev['fileEpsName'], error: t('worker.messages.validateCertificates.validationError') }}))
                }
                else if (typeFile === "arl") {
                    setErrors(prev => ({ ...prev, fileArlName : { ...prev['fileArlName'], error: t('worker.messages.validateCertificates.validationError') }}))
                }
                toast.error(validation.observation)
                toast.dismiss(toastShow);
                setLoading(false)
                return
            }

            const acceptAttribute = e.target.accept; // Obtiene el atributo accept del input
            const allowedExtensions = acceptAttribute.split(',').map(ext => ext.trim());

            const maxSizeInBytes = 10 * 1024 * 1024; // 10 MB
            if (file.size <= maxSizeInBytes) {
                const fileExtension = file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2); // Obtener la extensión del archivo
                if (allowedExtensions.includes('.' + fileExtension.toLowerCase())) {
                    if (typeFile === 'electrical') {
                        setForm(prev => ({ ...prev, fileName: file.name, file: file }));
                        setErrors(prev => ({ ...prev, fileName: { ...prev['fileName'], error: '' } }));

                    } else if (typeFile === 'eps') {
                        setForm(prev => ({ ...prev, fileEpsName: file.name, epsFile: file }));
                        setErrors(prev => ({ ...prev, fileEpsName: { ...prev['fileEpsName'], error: '' } }));
                    } else if (typeFile === 'arl') {
                        setForm(prev => ({ ...prev, fileArlName: file.name, arlFile: file }));
                        setErrors(prev => ({ ...prev, fileArlName: { ...prev['fileArlName'], error: '' } }));
                    }

                } else {
                    toast.error(t('worker.messages.uploadFile.typeError'))
                }
            } else {
                toast.error(t('worker.messages.uploadFile.maxSizeError'))
            }
        }
    }

    function checkForm() {
        const isEmailValid = checkEmailFormat(form.email);

        let validate = validateForm(form, errors)
        if (validate.hasErrors || !isEmailValid) {
            setErrors(validate.errors)
            return
        }
        handleSave(form, isRetieTechnicalCertificate)
    }

    async function getSpecialties() {

        const response = await workflowApi.getWorkerSpecialityRoles()

        const data = response.data.map(el => ({
            value: el.id,
            name: el.name
        }))
        setSpecialties(data)

    }

    async function getAssignations() {
        const response = await plantApi.getByUser();
        // Return only the ones that have category "Estación"
        const data = response.data?.filter((el) => {
            if (el.category?.id === 1) {
                return true
            }
        });

        setAssignations(data)
        return data
    }

    const checkEmailFormat = (email) => {
        const trimmedEmail = email?.trim();

        if (!trimmedEmail) {
            setErrors(prev => ({
                ...prev,
                email: {
                    ...prev.email,
                    error: ''
                }
            }));
            return true;
        }

        const isValid = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{1,}$/i.test(email);

        if (!isValid) {
            setErrors(prev => ({
                ...prev,
                email: {
                    ...prev.email,
                    error: t("system.validations.email")
                }
            }));
            return false;
        }

        // Limpiar error si ya es válido
        setErrors(prev => ({
            ...prev,
            email: {
                ...prev.email,
                error: ''
            }
        }));

        return true;
    };

    async function ValidateCertificates(file, type) {
        let formValidates = new FormData();
        let fullName = form.name + ' ' + form.lastName;
        formValidates.append('file', file)
        formValidates.append('identification', form.identification)
        formValidates.append('fullName', fullName)
        type === 'HEALTH' ? formValidates.append('epsName', form.eps.name) : formValidates.append('epsName', null)
        type === 'ARL' ? formValidates.append('arlName', form.arl.name) : formValidates.append('arlName', null)
        formValidates.append('affiliationType', type)

        let resp = await companyWorkerApi.validateCertificate(formValidates);
        if ([201, 200].includes(resp.status)) {
            return resp.data
        }else
        {
            toast.error('Error al validar el certificado')
            setLoading(false)
            toast.dismiss();            
        }

    }

    async function LoadArlEntities() {
        let resp = await companyWorkerApi.getArlEntities()
        if (([201, 200].includes(resp.status))) {

            const data = resp.data.map(el => ({
                value: el.value,
                name: el.name
            }))
            setArrayArl(data)

        }
    }

    async function LoadEpsEntities() {
        let resp = await companyWorkerApi.getEpsEntities()
        if (([201, 200].includes(resp.status))) {

            const data = resp.data.map(el => ({
                value: el.value,
                name: el.name
            }))
            setArrayEps(data)

        }
    }

    async function getRoleElectricalLevels() {
        const response = await workerCertificateApi.getRoleElectricalLevels();
        if (([201, 200].includes(response.status))) {
            setArrayRoleElectricalLevels(response.data)
            return response.data
        }
        return []
    }

    async function getCertificatesWithRoles(selectedOptions) {
        const response = await workerCertificateApi.getCertificatesWithRoles();
        if (([201, 200].includes(response.status))) {
            // Construir el array de certificados con las opciones disponibles y opciones seleccionadas
            response.data.forEach((cert) => {
                cert.selectedOptions = []
                cert.options.forEach((option) => {
                    const found = selectedOptions.find((el) => el.id === option.id);
                    if (found) {
                        // option.isValid = found.isValid;
                        option.isInvalid = found.certificationDate !== null && found.isValid == false && found.hasError == false;
                        option.isSpecial = found.certificationDate !== null && found.hasError == false;
                        option.isError = found.hasError;
                        cert.selectedOptions.push(option);
                    }
                })
            });

            console.log("response data ", response.data)
            return response.data;
        }
        return []
    }

    return (
        <Container>
            <ModalHeader>
				{data?.workerId ? t('worker.modal.edit') : t('worker.modal.create')}
			</ModalHeader>
			<ModalSubHeader/>
            <Body>
                <CompanyWorkerForms
                    isEdit={isEdit}
                    form={form}
                    errors={errors}
                    disabled={disabled}
                    specialties={specialties}
                    assignations={assignations}
                    handleChange={handleChange}
                    handleChangeCertificates={handleChangeCertificates}
                    arrayArl={arrayArl}
                    arrayEps={arrayEps}
                    isRetieTechnicalCertificate={isRetieTechnicalCertificate}
                    arrayRoleElectricalLevels={arrayRoleElectricalLevels}
                    handleChangeFile={handleChangeFile}
                />
            </Body>
            <ModalFooter>
                <SectionRight>
                    <CustomButtonV2
                        btnType="cancel"
                        onClick={handleClose}
                    >
                        {t('common.cancel')}
                    </CustomButtonV2>
                    <Spacer />
                    <CustomButtonV2
                        btnType="primary"
                        onClick={checkForm}
                    >
                        {t('common.save')}
                    </CustomButtonV2>
                </SectionRight>
            </ModalFooter>
            <BackdropLoading open={loading} />
        </Container>
    )
}